module.exports = __webpack_public_path__ + "img/client16.7d4fe50d.webp";